











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReflectionGroupHeader_reflectionGroup",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReflectionGroupTitleEditor_reflectionGroup"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReflectionGroupVoting_reflectionGroup"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RetroReflection",
      "kind": "LinkedField",
      "name": "reflections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RetroReflectionGroup",
  "abstractKey": null
};

(node ).hash = "21e6044547855b2221a9b1c15a96c591";

export default node;
